const SYNC_DOWNLOAD_URL =
  'https://s3-us-west-2.amazonaws.com/skupos-sync-releases/SKUPOSInstaller.exe';
export default SYNC_DOWNLOAD_URL;
